import { useAuth } from '../../context/AuthContext';

export function Header() {
  const { sites, currentSiteId, setCurrentSiteId } = useAuth();

  return (
    <header className="flex h-16 items-center justify-between border-b border-slate-200 bg-white px-6 dark:border-slate-800 dark:bg-slate-900">
      <div className="flex items-center gap-2">
        <label htmlFor="site-select" className="text-sm text-slate-500 dark:text-slate-400">
          Seite:
        </label>
        <select
          id="site-select"
          value={currentSiteId ?? ''}
          onChange={(e) => setCurrentSiteId(e.target.value)}
          className="rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-sm font-medium text-slate-900 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 dark:border-slate-700 dark:bg-slate-800 dark:text-white"
        >
          {sites.length === 0 && <option value="">Keine Seiten</option>}
          {sites.map((site) => (
            <option key={site.id} value={site.id}>
              {site.name}
            </option>
          ))}
        </select>
      </div>
    </header>
  );
}
